export const COLUMN_WIDTHS_STATE_FIELD = 'columnWidths';
